import { InstitutionalPage } from '@/components/institutional-page'

export function PrivacyPage() {
  return InstitutionalPage({
    title: 'Privacy Policy - ResumeHeaders',
    heading: 'Privacy Policy',
    markdownUrl: '/content/privacy.md',
    background: 'white',
    showHeader: true,
    showFooter: true,
  })
}
